/**
 * middleware/admin.global.ts
 *
 * Cualquier ruta bajo /admin/* requiere is_superadmin=true. Caso contrario,
 * redirige a /dashboard. Permite si el profile aún no carga (auth middleware
 * en curso); se re-evaluará en la siguiente nav.
 *
 * Excepción pata 2 (mig 1114, spec §8): un usuario con el permiso delegable
 * `dispute_ops` (sin ser super-admin) puede entrar SOLO a
 * /admin/labs/reportes — el gestor contratado resuelve disputas de
 * laboratorio, no el resto de /admin. Liquidar receivables sigue gateado por
 * is_superadmin en el propio store/UI (mover dinero real no se delega).
 */
import { useAuthStore } from '~/stores/auth'

const DISPUTE_OPS_ROUTE = '/admin/labs/reportes'

export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.startsWith('/admin')) return
  const auth = useAuthStore()
  if (!auth.profile) return
  if (auth.isSuperadmin) return
  if (to.path === DISPUTE_OPS_ROUTE && auth.hasAdminScope('dispute_ops')) return
  return navigateTo('/dashboard')
})
